"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelService = void 0;
var lodash_1 = require("lodash");
var DefaultLabelFields_1 = __importDefault(require("./DefaultLabelFields"));
var LabelService = (function () {
    function LabelService(accountQuoteSettings, uniqueId, $timeout) {
        var _this = this;
        this.accountQuoteSettings = accountQuoteSettings;
        this.uniqueId = uniqueId;
        this.$timeout = $timeout;
        this.getDefaultFields = function () {
            return (0, lodash_1.clone)(DefaultLabelFields_1.default);
        };
        this.getLabelSets = function () { return _this.accountQuoteSettings.labels; };
        this.getActiveLabelSets = function () {
            var allLabelSets = _this.getLabelSets();
            return (0, lodash_1.filter)(allLabelSets, { isActive: true });
        };
        this.getLabelSet = function (id) {
            if (!id) {
                return {
                    name: "Default Labels",
                    labels: (0, lodash_1.clone)(DefaultLabelFields_1.default),
                    id: "",
                    isActive: true,
                };
            }
            var allLabelSets = _this.getLabelSets();
            var labelSet = allLabelSets.find(function (set) { return set.id === id; });
            if (!labelSet) {
                return {
                    name: "Default Labels",
                    labels: (0, lodash_1.clone)(DefaultLabelFields_1.default),
                    id: "",
                    isActive: true,
                };
            }
            return (0, lodash_1.cloneDeep)(labelSet);
        };
        this.getLabel = function (id, field) {
            var _a;
            if (!field) {
                throw new Error("No label field given");
            }
            if (DefaultLabelFields_1.default[field] == null) {
                throw new Error("Not a valid label field");
            }
            var labelSet = _this.getLabelSet(id);
            if (((_a = labelSet.labels[field]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return labelSet.labels[field];
            }
            else {
                return DefaultLabelFields_1.default[field];
            }
        };
        this.updateLabelSet = function (id, name, labels) {
            if (!id) {
                throw new Error("No id given for label set");
            }
            if (!name) {
                throw new Error("No name given for label set");
            }
            if (!labels || Object.keys(labels).length === 0) {
                throw new Error("No labels given to update");
            }
            var allLabelSets = _this.getLabelSets();
            var labelSetIndex = (0, lodash_1.findIndex)(allLabelSets, { id: id });
            if (labelSetIndex < 0) {
                labelSetIndex = allLabelSets.length;
                allLabelSets.push({
                    id: id,
                    isActive: true,
                    name: "Untitled",
                    labels: {},
                });
            }
            allLabelSets[labelSetIndex].name = name;
            allLabelSets[labelSetIndex].labels = labels;
            return _this.$timeout(function () { });
        };
        this.createLabelSet = function () {
            var newLabels = (0, lodash_1.clone)(DefaultLabelFields_1.default);
            for (var field in newLabels) {
                newLabels[field] = "";
            }
            var newLabelSet = {
                name: "New Label Set",
                id: _this.uniqueId(),
                labels: newLabels,
                isActive: true,
            };
            return newLabelSet;
        };
        this.deleteLabelSet = function (id) {
            if (!id) {
                throw new Error("No id given for label set");
            }
            var toDeleteIndex = (0, lodash_1.findIndex)(_this.accountQuoteSettings.labels, { id: id });
            if (toDeleteIndex < 0) {
                throw new Error("Could not find label set to delete");
            }
            return _this.accountQuoteSettings.labels.splice(toDeleteIndex, 1);
        };
        if (!$timeout) {
            $timeout = (function () { });
        }
    }
    return LabelService;
}());
exports.LabelService = LabelService;
